// extracted by mini-css-extract-plugin
export default {"body":"GeneralLayout_body__InhDS","content":"GeneralLayout_content__91avf","main":"GeneralLayout_main__XnwDW","container":"GeneralLayout_container__vDwxg"};